module.exports = __webpack_public_path__ + "img/thumbnail_AsianWaterMonitor_m_albino.c5a3c473.png";